// Review item 6 — rótulo de máquina (nome + código em mono) reusado pelo card de eventos
// recentes (EventRow) e pelo diálogo de detalhe (EventDetailDialog).
interface MachineLabelProps {
  name: string;
  code?: string;
  className?: string;
}

export function MachineLabel({ name, code, className }: MachineLabelProps) {
  return (
    <span className={className}>
      {name}
      {code ? (
        <span className="ml-1.5 font-mono text-[11px] text-text-tertiary">{code}</span>
      ) : null}
    </span>
  );
}
